import { render } from "./ItemAccordion.vue?vue&type=template&id=2b44f2f6&scoped=true"
import script from "./ItemAccordion.vue?vue&type=script&lang=js"
export * from "./ItemAccordion.vue?vue&type=script&lang=js"

import "./ItemAccordion.vue?vue&type=style&index=0&id=2b44f2f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b44f2f6"

export default script